import { createSlice } from "@reduxjs/toolkit";

export const newContactsPageSlice = createSlice({
  name: "newContactsPageState",
  initialState: {
    filters: {
      page: 1,
      searchWord: "",
      sourceFilter: "",
      readFilter: "unread", // "read", "unread", or "" for all
      sortFilter: "submitted_at",
      sortAscending: false, // newest first
    },
    submissionsList: [],
    sourcesList: [],
    totalPages: 1,
    totalCount: 0,
  },
  reducers: {
    updateFilters: (state, action) => {
      state.filters = action.payload;
    },
    updateSubmissionsList: (state, action) => {
      const submissionsList = action.payload;
      if (Array.isArray(submissionsList)) {
        state.submissionsList = submissionsList;
      } else {
        state.submissionsList = [];
      }
    },
    updateSourcesList: (state, action) => {
      const sourcesList = action.payload;
      if (Array.isArray(sourcesList)) {
        state.sourcesList = sourcesList;
      } else {
        state.sourcesList = [];
      }
    },
    updatePagination: (state, action) => {
      const { totalPages, totalCount, page } = action.payload;
      state.totalPages = totalPages || 1;
      state.totalCount = totalCount || 0;
      if (page !== undefined) {
        state.filters.page = page;
      }
    },
    resetStateNewContactsPage: (state) => {
      state.filters = {
        page: 1,
        searchWord: "",
        sourceFilter: "",
        readFilter: "unread",
        sortFilter: "submitted_at",
        sortAscending: false,
      };
      state.submissionsList = [];
      state.sourcesList = [];
      state.totalPages = 1;
      state.totalCount = 0;
    },
  },
});

export const { 
  updateFilters, 
  updateSubmissionsList, 
  updateSourcesList,
  updatePagination,
  resetStateNewContactsPage 
} = newContactsPageSlice.actions;

export default newContactsPageSlice.reducer;

